export default __webpack_public_path__ + "static/media/trashcan.3a21fcff.svg";